let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8bYzb")).then(() => parcelRequire('6zUC5'));